import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActiveAlert, dismissAlert } from "../../store/alert/actions/actionsCreators";
import "./TopAlert.css";

const TopAlert = () => {
  const dispatch = useDispatch();
  const { activeAlert, isDismissed } = useSelector((state) => state.alert);

  useEffect(() => {
    // Fetch active alert on mount
    dispatch(getActiveAlert());

    // Poll for updates every 5 minutes
    const interval = setInterval(() => {
      dispatch(getActiveAlert());
    }, 300000); // 5 minutes

    return () => clearInterval(interval);
  }, [dispatch]);

  if (!activeAlert || isDismissed) return null;

  const getIcon = () => {
    switch (activeAlert.alertType) {
      case "WARNING":
        return "⚠️";
      case "MAINTENANCE":
        return "🔧";
      case "URGENT":
        return "🚨";
      default:
        return "ℹ️";
    }
  };

  const getAlertClass = () => {
    return `top-alert alert-${activeAlert.alertType.toLowerCase()}`;
  };

  return (
    <div className={getAlertClass()}>
      <div className="alert-content">
        <span className="alert-icon">{getIcon()}</span>
        <span className="alert-message">{activeAlert.message}</span>
      </div>
      <button
        className="alert-dismiss"
        onClick={() => dispatch(dismissAlert())}
        aria-label="Dismiss alert"
      >
        ×
      </button>
    </div>
  );
};

export default TopAlert;